/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import classNames from 'classnames'
import { IAttachment, IAttachmentStatus } from '../Media.model'
import { Link } from 'react-router-dom'
import { FormikProps } from 'formik'
import {get} from 'lodash'
import { sizeFormater } from '../../../common/component/FilePicker'

interface Props {
  disabled?: boolean
  attachment?: IAttachment
  idSelected?: string
  backgroundClass?: string
  hoverBackgroundClass?: string
  formik?: FormikProps<any>
  fieldName?: string
  rowOnClickHandler?: (id: string) => void
  deleteOnClickHandler?: (id: string) => void
  retryOnClickHandler?: (id: string) => void
  downloadOnClickHandler?: (id: string) => void
}

const AttachmentListItem: FC<Props> = ({
  disabled = false,
  attachment,
  idSelected,
  backgroundClass = 'bg-light-primary',
  hoverBackgroundClass = 'bg-hover-light-primary',
  formik,
  fieldName,
  rowOnClickHandler,
  deleteOnClickHandler,
  retryOnClickHandler,
  downloadOnClickHandler,
}: Props) => {
  if (formik && fieldName) {
    attachment = get(formik?.values, fieldName)
  }
  const backGroundClasses = {}
  backGroundClasses[`py-2 ${backgroundClass}`] = attachment?.id === idSelected
  const hoverBackGroundClasses = {}
  hoverBackGroundClasses[`py-2 ${hoverBackgroundClass}`] = attachment?.id !== idSelected

  return (
    <div className={classNames(backGroundClasses, hoverBackGroundClasses)}>
      {/* {formik && fieldName && (
        <div className='d-flex flex-row'>
          <div className='d-flex flex-column flex-row-auto'>
            <div className='d-flex flex-column-fluid flex-center'>
              {attachment.processing ? (
                <span className='indicator-progress mx-4' style={{display: 'block'}}>
                  <span className='spinner-border spinner-border-sm align-middle'></span>
                </span>
              ) : (
                <>
                  {attachment.path && (
                    <span
                      className='mx-5'
                      onClick={() =>
                        attachment &&
                        downloadOnClickHandler &&
                        downloadOnClickHandler(attachment.id)
                      }
                    >
                      <i className='bi bi-cloud-download text-success fs-3 cursor-pointer'></i>
                    </span>
                  )}
                </>
              )}
            </div>
          </div>

          <div
            className='d-flex flex-column flex-row-fluid'
            onClick={() => attachment && rowOnClickHandler && rowOnClickHandler(attachment.id)}
          >
            <span className='fs-7'>
              <Link to='#'>{attachment.fileName.toUpperCase()}</Link>
            </span>

            <div className='mt-0 lh-1'>
              <div className='d-flex justify-content-start'>
                <div className='d-flex align-items-center fs-8'>
                  <span className='text-gray-600'>{`${sizeFormater(
                    attachment.size
                  )} | ${attachment.contentType?.toUpperCase()}`}</span>
                </div>
              </div>
            </div>
            {attachment.error && (
              <div className='mt-1 lh-1'>
                <div className='d-flex justify-content-start'>
                  <div className='d-flex align-items-center fs-8'>
                    <span className='text-danger'>{attachment.error}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )} */}

      {attachment && (
        <div className='d-flex flex-row'>
          <div className='d-flex flex-column flex-row-auto'>
            <div className='d-flex flex-column-fluid flex-center'>
              {attachment.processing ? (
                <span className='indicator-progress mx-5' style={{display: 'block'}}>
                  <span className='spinner-border spinner-border-sm align-middle'></span>
                </span>
              ) : (
                <>
                  {!disabled && (
                    <>
                      {attachment?.status === IAttachmentStatus.NEW && (
                        <span
                          className='mx-5'
                          onClick={() =>
                            attachment &&
                            deleteOnClickHandler &&
                            deleteOnClickHandler(attachment.id)
                          }
                        >
                          <i className='bi bi-trash fw-bold text-danger fs-3 cursor-pointer'></i>
                        </span>
                      )}
                      {(attachment?.status === IAttachmentStatus.SAVED || attachment?.status === IAttachmentStatus.UPDATE) && (
                        <span
                          className='mx-5'
                          onClick={() =>
                            attachment &&
                            downloadOnClickHandler &&
                            downloadOnClickHandler(attachment.id)
                          }
                        >
                          <i className='bi bi-cloud-download text-success fs-3 cursor-pointer'></i>
                        </span>
                      )}
                      {attachment?.status === IAttachmentStatus.ERROR && (
                        <span
                          className='mx-5'
                          onClick={() =>
                            attachment && retryOnClickHandler && retryOnClickHandler(attachment?.id)
                          }
                        >
                          <i className='bi bi-arrow-clockwise text-warning fs-2 cursor-pointer'></i>
                        </span>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>

          <div
            className='d-flex flex-column flex-row-fluid'
            onClick={() => attachment && rowOnClickHandler && rowOnClickHandler(attachment.id)}
          >
            <span className='fs-7'>
              <Link to='#'>{attachment.fileName.toUpperCase()}</Link>
            </span>

            <div className='mt-0 lh-1'>
              <div className='d-flex justify-content-start'>
                <div className='d-flex align-items-center fs-8'>
                  <span className='text-gray-600'>{`${sizeFormater(
                    attachment.size
                  )} | ${attachment.contentType?.toUpperCase()}`}</span>
                </div>
              </div>
            </div>
            {attachment.error && (
              <div className='mt-1 lh-1'>
                <div className='d-flex justify-content-start'>
                  <div className='d-flex align-items-center fs-8'>
                    <span className='text-danger'>{attachment.error}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export {AttachmentListItem}
